/* @flow */

import React from "react";

import { BusinessAccount } from "../../../../datatypes/businessaccounts/BusinessAccount";
import { BusinessAccountAbbreviationCircle } from "./BusinessAccountAbbreviationCircle";
import { BusinessAccountStore } from "../../../../stores/businessaccounts/BusinessAccountStore";

type Props = {
    businessAccount: BusinessAccount;
    showAccountStatus?: boolean;
    activeAccountId?: string;
    clickable?: boolean;
};

export class BrandbarPopoverAccountComponent extends React.Component<Props> {
    onClick = (isSelectedAccount: boolean) => {
        if (this.accountIsSelectable(isSelectedAccount)) {
            BusinessAccountStore.setActiveAccount(this.props.businessAccount.id);
        }
    };

    accountIsSelectable(isSelectedAccount: boolean) {
        return this.props.clickable && !isSelectedAccount && this.props.businessAccount.validated;
    }

    render() {
        const isSelectedAccount = this.props.activeAccountId
            ? this.props.activeAccountId === this.props.businessAccount.id
            : false;
        const selectedClassName = this.props.showAccountStatus && isSelectedAccount ? " active" : "";
        const disabledClassName = this.props.businessAccount.validated ? "" : " disabled";
        const clickableClassName = this.accountIsSelectable(isSelectedAccount) ? " clickable" : "";
        return (
            <div
                className={
                    "dropdown-menu-item dropdown-menu-item-store" +
                    selectedClassName +
                    clickableClassName +
                    disabledClassName +
                    " test-switch"
                }
                onClick={() => this.onClick(isSelectedAccount)}>
                <div className="m-media">
                    <div className="m-media-visual">
                        <BusinessAccountAbbreviationCircle businessAccount={this.props.businessAccount} />
                    </div>
                    <div className="m-media-content">
                        <div className="m-address">
                            <strong>{this.props.businessAccount.corporateName}</strong>
                            <br />
                            <em>{this.props.businessAccount.address}</em>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
